import { RouterProvider } from "react-router-dom";
import './styles/main.scss';

import { router } from './routes/routes';
import './styles/main.scss';

function App() {

  return (
    <RouterProvider router={router} />
  );
}

export default App;
